import {Component, OnInit} from '@angular/core';
import {AngularFirestore} from "@angular/fire/firestore";
import {MagliveApiClient} from "../../../../lib/api-client/maglive-api-client";
import * as Rx from 'rxjs';
import {map} from "rxjs/operators";
import {
  Live,
  LiveComment,
} from "../../../../lib/entity/live";

export type DeleteCommentTargetLiveQuery = {
  kind: 'on_air',
  value: boolean
} | {
  kind: 'createdAt',
  value: 'desc' | 'asc'
} | {
  kind: 'magazineId',
  value: number
}

@Component({
  selector: 'maglive-admin-comment-delete',
  styleUrls: ['./comment-delete.component.scss'],
  templateUrl: './comment-delete.component.html'
})

export class CommentDeleteComponent implements OnInit {

  deleteCommentTargetLives$: Rx.Observable<Live[]>;
  deleteCommentTargetLiveComments$: Rx.Observable<LiveComment[]>;
  deleteCommentTargetLiveQuery: DeleteCommentTargetLiveQuery = {kind: 'on_air', value: true};
  deleteCommentTargetLiveQueryOption: ({label: string} & DeleteCommentTargetLiveQuery)[] = [
    {kind: 'on_air', value: true, label: '映像を配信中のライブのみ'},
    {kind: 'createdAt', value: 'desc', label: '作成日の新しい順'},
    {kind: 'magazineId', value: 0, label: 'メルマガ ID を指定'}
  ];
  deleteCommentTargetLiveLimit: number = 50;
  deleteCommentTargetLive: Live;

  constructor(
    private afs: AngularFirestore,
  ) {}

  ngOnInit(): void {
    this.deleteCommentTargetLiveQuery = this.deleteCommentTargetLiveQueryOption[0];
    this.reloadDeleteCommentTargetLive();
    this.reloadDeleteCommentTargetLiveComments();
  }

  reloadDeleteCommentTargetLive() {
    this.deleteCommentTargetLive = null;
    this.deleteCommentTargetLives$ = this.afs.collection<Live>('lives', ref => {
        if (this.deleteCommentTargetLiveQuery.kind === 'on_air') {
          return ref
            .limit(this.deleteCommentTargetLiveLimit)
            .where("status", '==', "ON_AIR")
        } else if (this.deleteCommentTargetLiveQuery.kind === 'createdAt') {
          return ref
            .limit(this.deleteCommentTargetLiveLimit)
            .orderBy("createdAt", this.deleteCommentTargetLiveQuery.value)
        } else if (this.deleteCommentTargetLiveQuery.kind === 'magazineId') {
          return ref
            .limit(this.deleteCommentTargetLiveLimit)
            .where("magazineId", '==', this.deleteCommentTargetLiveQuery.value)
        } else {
          console.error(this.deleteCommentTargetLiveQuery);
        }
      }
    ).valueChanges();
  }

  private reloadDeleteCommentTargetLiveComments() {
    if (!this.deleteCommentTargetLive) {
      console.log("[delete comment] Target live is empty.");
      this.deleteCommentTargetLiveComments$ = Rx.of([]);
      return;
    }
    this.deleteCommentTargetLiveComments$ = this.afs.collection<LiveComment>(`lives/${this.deleteCommentTargetLive.id}/comments`, ref =>
      ref.orderBy("createdAt", "desc")
    ).snapshotChanges().pipe(map(comments => {
        return comments.map(x => {
          const data = x.payload.doc.data();
          const id = x.payload.doc.id;
          return {id, ...data}
        })
      })
    );
  }

  selectDeleteCommentLive(live: Live) {
    this.deleteCommentTargetLive = live;
    this.reloadDeleteCommentTargetLiveComments();
  }

  deleteComment(commentId: string) {
    MagliveApiClient.deleteComment(this.deleteCommentTargetLive.id, commentId)
      .subscribe(() => setTimeout(() => this.reloadDeleteCommentTargetLiveComments(), 500))
  }
}